<section>

  <div class="flex justify-between items-end">
    <div>
      <h1>Staff List</h1>
    </div>
    <div class="flex items-center gap-3">
      <div class="dropdown dropdown-bottom dropdown-end">
        <div *ngIf="staff_import_export" tabindex="0" role="button" class="btn btn-sm bg-white  border flex items-center">Action <i
            class="ri-arrow-down-s-line"></i></div>
        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li *ngIf="staff_import_export"><label for="staff-import-file" class="cursor-pointer">Import via CSV</label></li>
          <li *ngIf="staff_import_export"><a (click)="exportData('pdf')">Export PDF</a></li>
          <li *ngIf="staff_import_export"><a (click)="exportData('csv')">Export CSV</a></li>
          <li *ngIf="staff_import_export"><a (click)="exportData('excel')">Export Excel</a></li>
        </ul>
      </div>
      <input id="staff-import-file" type="file" accept=".csv" class="hidden" (change)="handleImportFile($event)" />
      <a *ngIf="create_staff" (click)="showStaffFormModal('new')" class="btn btn-sm flex items-center btn-primary"><i
          class="ri-add-line"></i> Create Staff</a>

    </div>
  </div>

  <!-- serach Parameter form -->
  <div class="mt-5">
    <div class="bg-white border border-gray-200 rounded-lg flex items-center w-2/5 px-3"><i
        class="ri-search-2-line"></i> <input type="text" [(ngModel)]="searchStr" (ngModelChange)="search()"
        placeholder="Search" class="outline-none ml-2 w-full py-2">
    </div>
  </div>
  <!-- serach Parameter form -->

  <div *ngIf="list_staff" class="p-5 bg-white rounded-lg mt-5 border">

    <div class="overflow-x-auto">
      <table class="table table-auto w-full">
        <!-- head -->
        <thead>
          <tr>
            <!-- <th class="w-14"><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
            <th class="w-auto">Name</th>
            <th>Contact Details</th>
            <th>Department</th>
            <th class="w-56">Action</th>
          </tr>
        </thead>
        <tbody>
          @if (isFetching) {
          <tr>
            <td colspan="5" class="py-10">
              <div class="flex justify-center">
                <app-loader></app-loader>
              </div>
            </td>
          </tr>
          } @else {
          @if (staffList && staffList.length) {
          @for (i of staffList; track $index) {
          <tr>
            <!-- <th><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
            <td class="break-words">{{i?.name}}</td>
            <td class="flex flex-col">
              <span>{{i?.mobile}}</span>
              <span>{{i?.email}}</span>
            </td>
            <td>{{i?.department ?? '-'}}</td>
            <td>
              <div class="flex gap-2 justify-center">
                <a *ngIf="view_staff" [routerLink]="['/staff', i?.id]" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-eye-line"></i></a>
                <a *ngIf="edit_staff" (click)="showStaffFormModal('edit',i?.id)" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-pencil-line"></i></a>
                <button *ngIf="delete_staff" class="btn btn-sm flex items-center btn-light" (click)="deletestaff(i?.id)">
                  <i class="ri-delete-bin-line"></i>
                </button>
                <!--
              <a [routerLink]="['/performance','student',i?.id]" class="btn btn-sm flex items-center btn-light"><i class="ri-bar-chart-line"></i></a>
              <button class="btn btn-sm flex items-center btn-light"><i class="ri-message-3-line"></i></button>
              -->
              </div>
            </td>
          </tr>
          }
          } @else {
          <tr>
            <td colspan="5" class="py-10">
              <div class="flex justify-center">
                <p>No data to display.</p>
              </div>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>



  </div>



  <div class="mt-5 flex justify-center" *ngIf="list_staff">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>


</section>
<!-- create/edit student modal -->
@if (isMoaldalOpen) {
<app-staff-common-form-modal [isOpen]="isMoaldalOpen" [userId]="staffId" userType="STAFF"
  (closeModalemmit)="emitedData($event)"></app-staff-common-form-modal>
}
<!-- create/edit student modal -->
